import { createFileRoute } from '@tanstack/react-router'
import { DocumentTaxonomy } from '@/features/document-taxonomy'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/document-taxonomy/')({
  beforeLoad: requireAdmin,
  component: DocumentTaxonomy,
})
